// extracted by mini-css-extract-plugin
module.exports = {"base":"TenureOption_base__FBu1Q","active":"TenureOption_active__pfolF","inactive":"TenureOption_inactive__7i_ve"};